@if (show === 'text') {
  {{ trackingData }}
}
@if (show === 'link') {
  @if (trackingNumbers[0]; as firstTrack) {
    @if (hasAftership(firstTrack.has_aftership)) {
      <a
        class="link link-underline small"
        [href]="firstTrack.url"
        title="Click to view more"
        target="_blank"
        >{{ firstTrack.number }}</a
      >
    } @else {
      <a class="link small cursor-auto">{{ firstTrack.number }}</a>
    }
    <span>{{ firstTrack.slug | translate }}</span>
  }
}
@if (show === 'vendor') {
  <app-vendor-modal
    [vendorLabel]="vendor"
    buttonLabel="Shipped from "
  ></app-vendor-modal>
}
@if (show === 'modal') {
  <button class="tracking--view-all" (click)="onShowDetails(content)">
    View All
  </button>
  <ng-template #content let-modal>
    <div class="modal-header">
      <button
        type="button"
        class="close btn btn-icon"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true" class="fal fa-times"></span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container tracking--list">
        <div class="row font-5 uppercase">
          <div class="col-4 tracking--header">Status</div>
          <div class="col-8 tracking--header">Tracking</div>
        </div>
        <div class="row">
          <div class="col-12"></div>
        </div>
        @for (track of trackingNumbers; track track) {
          <div class="row">
            <div
              class="col-4 tracking--state"
              [ngClass]="{ delivered: isDelivered(track.status) }"
              [innerHTML]="track.status | translate"
            ></div>
            <div class="col-8 tracking--link">
              @if (track.mode === 'link') {
                @if (hasAftership(track.has_aftership)) {
                  <a
                    class="link link-underline small"
                    [href]="track.url"
                    title="Click to view more"
                    target="_blank"
                    >{{ track.number }}</a
                  >
                } @else {
                  <a class="link small cursor-auto">{{ track.number }}</a>
                }
                <span> {{ track.slug | translate }}</span>
              }
              @if (track.mode === 'vendor') {
                <app-vendor-modal
                  [vendorLabel]="vendor"
                  buttonLabel="Shipped from "
                ></app-vendor-modal>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
}
